import { inject, Injectable, signal } from '@angular/core';
import type { Attributes, GrowthBook } from '@growthbook/growthbook';
import { EnvironmentService } from '@pinnakl/core/environment';

@Injectable({
  providedIn: 'root',
})
export class GrowthBookService {
  private readonly environmentService = inject(EnvironmentService);
  private readonly revision = signal(0);
  private growthbook?: GrowthBook;
  private attributes: Attributes = {};

  async initialize(): Promise<void> {
    const clientKey = this.environmentService.environment?.growthbookClientKey;
    if (!clientKey) {
      console.error('GrowthBookService can not be initialized. No Client Key found.');
      return;
    }
    const [{ GrowthBook }, { autoAttributesPlugin }] = await Promise.all([
      import('@growthbook/growthbook'),
      import('@growthbook/growthbook/plugins'),
    ]);
    this.growthbook = new GrowthBook({
      apiHost: 'https://cdn.growthbook.io',
      clientKey,
      attributes: this.attributes,
      enableDevMode: !this.environmentService.environment?.production,
      plugins: [autoAttributesPlugin()],
      renderer: () => this.revision.update(revision => revision + 1),
    });
    await this.growthbook.init({ streaming: false });
  }

  async updateAttributes(attributes: Attributes): Promise<void> {
    this.attributes = { ...this.attributes, ...attributes };
    await this.growthbook?.updateAttributes(attributes);
  }

  isOn(key: string): boolean {
    this.revision();
    return this.growthbook?.isOn(key) ?? false;
  }
}
